import { render, staticRenderFns } from "./WrongStatus.vue?vue&type=template&id=0a0fadeb&"
import script from "./WrongStatus.vue?vue&type=script&lang=js&"
export * from "./WrongStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports